import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';

import TrackActions from 'app/track/TrackActions';
import ZapbookActions from 'app/zapbook/ZapbookActions';
import ZapbookStateful from 'app/zapbook/components/ZapbookStateful';
import { REDIRECT_404_URL } from 'app/company-dashboard/utils/const';
import { extractParamsFromHash } from 'app/common/utils/UrlUtils';
import {
  getCurrentHref,
  getCurrentPathname,
  getLandingPageName,
} from 'app/common/utils/RouterSelectors';

const mapStateToProps = state => {
  const currentHref = getCurrentHref(state);
  const params = currentHref ? extractParamsFromHash(currentHref) : null;
  const landingPageName = getLandingPageName(state);
  const currentPathname = getCurrentPathname(state);
  return {
    sortBy: params.hasOwnProperty('sort') ? params.sort : 'popular',
    oldFilterBy: params.hasOwnProperty('filter') ? params.filter : undefined,
    filterBy: state.router.current.params.categorySlug || 'all',
    isZapbookPage: landingPageName === 'zb no service',
    isCategoryPage: landingPageName === 'zb category page',
    isOneServicePage:
      currentPathname !== '/apps' &&
      // Allows /categories page to display categories on right side
      !currentPathname.includes('/apps/categories'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateHash(category, filter) {
      return dispatch(ZapbookActions.addParamsToHash(category, filter));
    },
    onTrack(message, data = null) {
      dispatch(TrackActions.track(message, data));
    },
    updateCategory(category, sortBy) {
      return dispatch(ZapbookActions.routeToCategory(category, sortBy));
    },
    onRedirectTo404() {
      return dispatch(routeTo(REDIRECT_404_URL));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ZapbookStateful);
